import type { FormatLabelFn } from '@@partner:types:app'

import {
  PRODUCT_REVIEW_STATUS_REJECTED,
  PRODUCT_REVIEW_STATUS_AWAITING_MODERATION,
  PRODUCT_REVIEW_STATUS_PASSED_MODERATION
} from '@@partner:config/productReview-status-codes'

/*
  Get order status label by status code
*/

export const formatProductReviewStatusLabel: FormatLabelFn = (value) => {
  switch (value) {
  case PRODUCT_REVIEW_STATUS_REJECTED:
    return { label: 'Отклонен', color: 'red' }
  case PRODUCT_REVIEW_STATUS_AWAITING_MODERATION:
    return { label: 'Ожидает модерации', color: 'yellow' }
  case PRODUCT_REVIEW_STATUS_PASSED_MODERATION:
    return { label: 'Прошел модерацию', color: 'green' }

  default:
    return {
      label: `Неопределённый статус ${status}`,
      color: 'red'
    }
  }
}
